export type EventType = 'offline' | 'online' | 'hybrid';
export type EventStatus = 'upcoming' | 'past';

export interface GtraEvent {
  id: string;
  title: string;
  titleEn: string;
  date: string;
  endDate: string;
  location: string;
  locationEn: string;
  country: string;
  region: 'asia' | 'europe' | 'americas' | 'africa' | 'oceania';
  type: EventType;
  status: EventStatus;
  cover: string;
  description: string;
  descriptionEn: string;
  tags: string[];
  tagsEn: string[];
  month: number;
}

export const events: GtraEvent[] = [
  {
    id: 'gts-2026',
    title: '2026全球科创峰会',
    titleEn: '2026 Global Tech Innovation Summit',
    date: '2026-04-15',
    endDate: '2026-04-17',
    location: '加州，美国',
    locationEn: 'California, USA',
    country: '美国',
    region: 'americas',
    type: 'offline',
    status: 'upcoming',
    cover: '/images/events/event-gts-2026.png',
    description: '汇聚全球科技创新领袖，共同探讨人工智能、量子计算、生命科学等前沿领域的最新突破与未来趋势，规模最大的科创年度盛典。',
    descriptionEn: 'Bringing together global tech innovation leaders to explore cutting-edge breakthroughs and future trends in AI, quantum computing, and life sciences at our flagship annual event.',
    tags: ['人工智能', '量子计算', '科创政策'],
    tagsEn: ['Artificial Intelligence', 'Quantum Computing', 'Innovation Policy'],
    month: 4,
  },
  {
    id: 'art-2026',
    title: 'AI前沿圆桌论坛',
    titleEn: 'AI Frontier Roundtable Forum',
    date: '2026-08-08',
    endDate: '2026-08-09',
    location: '柏林，德国',
    locationEn: 'Berlin, Germany',
    country: '德国',
    region: 'europe',
    type: 'hybrid',
    status: 'upcoming',
    cover: '/images/events/event-gts-2026.png',
    description: '聚焦人工智能最新研究方向，由来自MIT、马普学会、ETH等顶尖机构的研究者共同参与，探讨大模型、多模态AI与AI伦理前沿议题。',
    descriptionEn: 'Focused on the latest AI research directions, with researchers from MIT, Max Planck Society, and ETH exploring large language models, multimodal AI, and AI ethics.',
    tags: ['人工智能', '大语言模型', 'AI伦理'],
    tagsEn: ['Artificial Intelligence', 'Large Language Models', 'AI Ethics'],
    month: 8,
  },
  {
    id: 'gtf-2026',
    title: '绿色科技创新论坛',
    titleEn: 'Green Technology Innovation Forum',
    date: '2026-04-20',
    endDate: '2026-04-21',
    location: '新加坡',
    locationEn: 'Singapore',
    country: '新加坡',
    region: 'asia',
    type: 'offline',
    status: 'upcoming',
    cover: '/images/events/event-gts-2026.png',
    description: '汇聚全球清洁能源与可持续科技领域专家，探讨碳中和路径、新能源技术突破和绿色创新生态系统建设。',
    descriptionEn: 'Gathering global experts in clean energy and sustainable technology to explore carbon neutrality pathways, new energy breakthroughs, and green innovation ecosystems.',
    tags: ['清洁能源', '碳中和', '可持续发展'],
    tagsEn: ['Clean Energy', 'Carbon Neutrality', 'Sustainable Development'],
    month: 4,
  },
  {
    id: 'fms-2026',
    title: '未来出行创新峰会',
    titleEn: 'Future Mobility Innovation Summit',
    date: '2026-05-12',
    endDate: '2026-05-14',
    location: '纽约，美国',
    locationEn: 'New York, USA',
    country: '美国',
    region: 'americas',
    type: 'hybrid',
    status: 'upcoming',
    cover: '/images/events/event-gts-2026.png',
    description: '聚焦自动驾驶、电动出行与智慧交通系统，探索未来城市出行的技术边界与商业模式创新。',
    descriptionEn: 'Focused on autonomous driving, electric mobility, and intelligent transportation systems, exploring the technological frontiers and business model innovations of future urban mobility.',
    tags: ['自动驾驶', '智慧城市', '新能源汽车'],
    tagsEn: ['Autonomous Driving', 'Smart Cities', 'Electric Vehicles'],
    month: 5,
  },
  {
    id: 'qcs-2026',
    title: '量子计算国际研讨会',
    titleEn: 'International Quantum Computing Symposium',
    date: '2026-09-05',
    endDate: '2026-09-07',
    location: '北京，中国',
    locationEn: 'Beijing, China',
    country: '中国',
    region: 'asia',
    type: 'offline',
    status: 'upcoming',
    cover: '/images/events/event-gts-2026.png',
    description: '汇聚全球量子计算领域顶尖研究者，探讨量子纠错、量子算法、量子通信等核心技术突破与产业化路径。',
    descriptionEn: 'Bringing together top quantum computing researchers globally to discuss breakthroughs in quantum error correction, quantum algorithms, quantum communication, and industrialization pathways.',
    tags: ['量子计算', '量子通信', '量子密码'],
    tagsEn: ['Quantum Computing', 'Quantum Communication', 'Quantum Cryptography'],
    month: 9,
  },
  {
    id: 'lsf-2026',
    title: '生命科学创新论坛',
    titleEn: 'Life Sciences Innovation Forum',
    date: '2026-10-18',
    endDate: '2026-10-20',
    location: '伦敦，英国',
    locationEn: 'London, UK',
    country: '英国',
    region: 'europe',
    type: 'hybrid',
    status: 'upcoming',
    cover: '/images/events/event-gts-2026.png',
    description: '聚焦基因组学、合成生物学、精准医疗等生命科学前沿领域，汇聚全球顶尖生物医学研究者与产业领袖。',
    descriptionEn: 'Focused on genomics, synthetic biology, and precision medicine, bringing together top global biomedical researchers and industry leaders.',
    tags: ['基因组学', '合成生物学', '精准医疗'],
    tagsEn: ['Genomics', 'Synthetic Biology', 'Precision Medicine'],
    month: 10,
  },
  // ===== 历史活动 2025 =====
  {
    id: 'gts-2025',
    title: '2025全球科创峰会',
    titleEn: '2025 Global Tech Innovation Summit',
    date: '2025-06-20',
    endDate: '2025-06-22',
    location: '深圳，中国',
    locationEn: 'Shenzhen, China',
    country: '中国',
    region: 'asia',
    type: 'offline',
    status: 'past',
    cover: '/images/events/event-gts-2026.png',
    description: '第二届全球科创峰会在深圳盛大举行，汇聚全球42个国家超过500位科创领袖，围绕"智能未来：科技重塑人类生活"主题展开深度对话，达成28项跨国科研合作协议。',
    descriptionEn: 'The 2nd Global Tech Innovation Summit was grandly held in Shenzhen, bringing together over 500 innovation leaders from 42 countries to discuss "Intelligent Future: Technology Reshaping Human Life," resulting in 28 cross-border research collaboration agreements.',
    tags: ['人工智能', '智慧城市', '科创政策'],
    tagsEn: ['Artificial Intelligence', 'Smart Cities', 'Innovation Policy'],
    month: 6,
  },
  {
    id: 'qcs-2025',
    title: '量子计算国际研讨会',
    titleEn: 'International Quantum Computing Symposium',
    date: '2025-09-10',
    endDate: '2025-09-12',
    location: '东京，日本',
    locationEn: 'Tokyo, Japan',
    country: '日本',
    region: 'asia',
    type: 'offline',
    status: 'past',
    cover: '/images/events/event-gts-2026.png',
    description: '由GTRA与东京大学、理化学研究所联合主办，聚焦量子纠错与量子优越性验证，38位量子领域顶尖科学家分享最新研究成果，发布2份联合研究声明。',
    descriptionEn: 'Co-hosted by GTRA, the University of Tokyo, and RIKEN, focusing on quantum error correction and quantum advantage verification, with 38 leading quantum scientists sharing their latest research and publishing 2 joint research statements.',
    tags: ['量子计算', '量子通信', '量子纠错'],
    tagsEn: ['Quantum Computing', 'Quantum Communication', 'Quantum Error Correction'],
    month: 9,
  },
  {
    id: 'gtf-2025',
    title: '绿色科技创新论坛',
    titleEn: 'Green Technology Innovation Forum',
    date: '2025-04-15',
    endDate: '2025-04-16',
    location: '阿布扎比，阿联酋',
    locationEn: 'Abu Dhabi, UAE',
    country: '阿联酋',
    region: 'africa',
    type: 'hybrid',
    status: 'past',
    cover: '/images/events/event-gts-2026.png',
    description: '与阿布扎比可持续发展周同期举办，汇聚全球能源转型领域精英，探讨氢能、新型光伏和碳捕捉技术的最新突破，150+企业代表参与洽谈绿色投资合作。',
    descriptionEn: 'Held concurrently with Abu Dhabi Sustainability Week, bringing together global energy transition leaders to discuss breakthroughs in hydrogen energy, next-gen solar PV, and carbon capture technologies, with 150+ corporate representatives exploring green investment partnerships.',
    tags: ['清洁能源', '碳中和', '氢能源'],
    tagsEn: ['Clean Energy', 'Carbon Neutrality', 'Hydrogen Energy'],
    month: 4,
  },
  {
    id: 'lsf-2025',
    title: '生命科学创新论坛',
    titleEn: 'Life Sciences Innovation Forum',
    date: '2025-10-22',
    endDate: '2025-10-24',
    location: '巴黎，法国',
    locationEn: 'Paris, France',
    country: '法国',
    region: 'europe',
    type: 'hybrid',
    status: 'past',
    cover: '/images/events/event-gts-2026.png',
    description: '在巴黎巴斯德研究所举办，来自28个国家的生物医学领袖共同探讨基因编辑、mRNA疫苗技术及AI辅助药物研发的最新进展，孵化7个跨国联合研究项目。',
    descriptionEn: 'Held at the Institut Pasteur, biomedical leaders from 28 countries explored advances in gene editing, mRNA vaccine technology, and AI-assisted drug development, incubating 7 cross-national joint research projects.',
    tags: ['基因编辑', 'mRNA技术', '精准医疗'],
    tagsEn: ['Gene Editing', 'mRNA Technology', 'Precision Medicine'],
    month: 10,
  },
  // ===== 历史活动 2024 =====
  {
    id: 'gts-2024',
    title: '2024全球科创峰会（首届）',
    titleEn: '2024 Global Tech Innovation Summit (Inaugural)',
    date: '2024-06-18',
    endDate: '2024-06-20',
    location: '北京，中国',
    locationEn: 'Beijing, China',
    country: '中国',
    region: 'asia',
    type: 'offline',
    status: 'past',
    cover: '/images/events/event-gts-2026.png',
    description: 'GTRA首届全球科创峰会在北京国家会议中心隆重举办，来自30个国家的350位科技领袖、学者与创新企业代表共聚一堂，正式宣告GTRA全球合作网络正式建立。',
    descriptionEn: 'GTRA\'s inaugural Global Tech Innovation Summit was grandly held at the China National Convention Center in Beijing, with 350 tech leaders, scholars, and enterprise representatives from 30 countries officially inaugurating the GTRA global cooperation network.',
    tags: ['创始峰会', '全球合作', '科技创新'],
    tagsEn: ['Inaugural Summit', 'Global Cooperation', 'Tech Innovation'],
    month: 6,
  },
  {
    id: 'art-2024',
    title: 'AI前沿圆桌论坛',
    titleEn: 'AI Frontier Roundtable Forum',
    date: '2024-11-05',
    endDate: '2024-11-06',
    location: '旧金山，美国',
    locationEn: 'San Francisco, USA',
    country: '美国',
    region: 'americas',
    type: 'hybrid',
    status: 'past',
    cover: '/images/events/event-gts-2026.png',
    description: '在硅谷核心地带举办，汇聚OpenAI、DeepMind、百度等AI领军企业及学术界专家，深度探讨大语言模型的安全对齐、AI监管政策及多模态AI的产业化路径。',
    descriptionEn: 'Held in the heart of Silicon Valley, bringing together AI leaders from OpenAI, DeepMind, Baidu, and academia to deeply explore LLM safety alignment, AI regulation policies, and the industrialization of multimodal AI.',
    tags: ['人工智能', '大语言模型', 'AI治理'],
    tagsEn: ['Artificial Intelligence', 'Large Language Models', 'AI Governance'],
    month: 11,
  },
];

export const futurePlans = [
  {
    id: 'fp1',
    title: '2027全球科创圆桌年会',
    titleEn: '2027 GTRA Annual Assembly',
    period: '2027年第一季度',
    periodEn: 'Q1 2027',
    theme: '以科技重塑未来：边界消解与共融创新',
    themeEn: 'Reshaping the Future with Technology: Dissolving Boundaries and Inclusive Innovation',
    audience: '各国政府官员、顶尖学者、企业创新领袖',
    audienceEn: 'Government Officials, Top Scholars, Corporate Innovation Leaders',
  },
  {
    id: 'fp2',
    title: '女性科创领袖峰会',
    titleEn: 'Women in Tech Innovation Summit',
    period: '2026年11月',
    periodEn: 'November 2026',
    theme: '多元创新力：女性科学家与技术领袖的全球影响力',
    themeEn: 'Diverse Innovation Power: Global Impact of Women Scientists and Tech Leaders',
    audience: '女性科学家、工程师、创业者',
    audienceEn: 'Women Scientists, Engineers, Entrepreneurs',
  },
  {
    id: 'fp3',
    title: '青年创新者全球挑战赛',
    titleEn: 'Global Youth Innovators Challenge',
    period: '2026年12月',
    periodEn: 'December 2026',
    theme: '下一代科技突破：青年创新者的全球舞台',
    themeEn: 'Next-Generation Tech Breakthroughs: A Global Stage for Young Innovators',
    audience: '35岁以下青年科学家与创业者',
    audienceEn: 'Young Scientists and Entrepreneurs Under 35',
  },
];
